__turbopack_context__.v({
  "className": "geist_d89c3a2d-module__Y9tc_q__className",
  "variable": "geist_d89c3a2d-module__Y9tc_q__variable",
});
